import React from 'react';

export function ToneSelect({ tones, tone, setTone, disclaimer, generating, onBack, onGenerate }) {
  return (
    <div>
      <h2 className="mb-1 text-lg font-semibold text-slate-900 dark:text-white">How should it sound?</h2>
      <p className="mb-4 text-sm text-slate-600 dark:text-slate-300">
        Pick the tone that fits your situation — you can edit every word afterward.
      </p>
      <div className="space-y-3">
        {tones.map((t) => (
          <label
            key={t.key}
            className={`flex cursor-pointer items-start gap-3 rounded-xl border p-4 transition ${
              tone === t.key
                ? 'border-emerald-500 bg-emerald-50 dark:bg-emerald-900/30'
                : 'border-slate-200 bg-white hover:border-emerald-300 dark:border-slate-700 dark:bg-slate-800'
            }`}
          >
            <input
              type="radio"
              name="tone"
              value={t.key}
              checked={tone === t.key}
              onChange={() => setTone(t.key)}
              className="mt-1"
            />
            <span>
              <span className="block font-semibold text-slate-900 dark:text-white">{t.name}</span>
              <span className="block text-sm text-slate-600 dark:text-slate-300">{t.description}</span>
            </span>
          </label>
        ))}
      </div>
      <p className="mt-5 rounded-lg bg-amber-50 px-4 py-3 text-xs text-amber-900 dark:bg-amber-900/30 dark:text-amber-200">
        {disclaimer} If your question needs a legal opinion, talk with a licensed attorney.
      </p>
      <div className="mt-6 flex justify-between">
        <button type="button" onClick={onBack} className="rounded-lg px-4 py-2 text-sm font-medium text-slate-600 hover:bg-slate-100 dark:text-slate-300 dark:hover:bg-slate-800">
          Back
        </button>
        <button
          type="button"
          disabled={!tone || generating}
          onClick={onGenerate}
          className="rounded-lg bg-emerald-600 px-5 py-2 text-sm font-semibold text-white hover:bg-emerald-700 disabled:opacity-50"
        >
          {generating ? 'Writing your request…' : 'I understand — generate my request'}
        </button>
      </div>
    </div>
  );
}
